/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Step_Share_BodyInputs */

const en_platform_step_share_body = /** @type {(inputs: Platform_Step_Share_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Put your page in your bio or send it to clients. They book straight away.`)
};

const pl_platform_step_share_body = /** @type {(inputs: Platform_Step_Share_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wklej swoją stronę w bio albo wyślij podopiecznym. Rezerwują od razu.`)
};

/**
* | output |
* | --- |
* | "Put your page in your bio or send it to clients. They book straight away." |
*
* @param {Platform_Step_Share_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_step_share_body = /** @type {((inputs?: Platform_Step_Share_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Step_Share_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_step_share_body(inputs)
	return en_platform_step_share_body(inputs)
});